export default "__VITE_ASSET__B3Jff2Zd__"